<template>
  <div class="row mt-4">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-0">{{ $t('panelCliente.resumenTitulo') }}</h6>
              <p class="text-sm mb-0 opacity-7" v-if="cuenta">
                {{ $t('panelCliente.clienteLabel') }} <b>{{ cuenta.name || cuenta.username || "-" }}</b>
              </p>
            </div>
          </div>

          <div class="row g-3">
            <div class="col-6 col-lg-3 col-xl-2">
              <div class="mini-card">
                <div class="k">{{ $t('panelCliente.serviciosComprados') }}</div>
                <div class="v">{{ resumen.total_pedidos ?? 0 }}</div>
              </div>
            </div>
            <div class="col-6 col-lg-3 col-xl-2">
              <div class="mini-card">
                <div class="k">{{ $t('panelCliente.serviciosActivos') }}</div>
                <div class="v">{{ resumen.servicios_activos ?? 0 }}</div>
              </div>
            </div>
            <div class="col-6 col-lg-3 col-xl-2">
              <div class="mini-card">
                <div class="k">{{ $t('panelCliente.canalesUnidos') }}</div>
                <div class="v">{{ resumen.canales_unidos ?? 0 }}</div>
              </div>
            </div>
            <div class="col-6 col-lg-3 col-xl-2">
              <div class="mini-card">
                <div class="k">{{ $t('panelCliente.devoluciones') }}</div>
                <div class="v">{{ resumen.total_devoluciones ?? 0 }}</div>
              </div>
            </div>
            <div class="col-12 col-lg-3 col-xl-4">
              <div class="mini-card">
                <div class="k">{{ $t('panelCliente.ultimaCompra') }}</div>
                <div class="v text-sm">{{ fmtFechaHora(resumen.ultima_compra) }}</div>
              </div>
            </div>
          </div>

          <div v-if="!loading && !hayDatos" class="mt-4 alert alert-secondary text-sm">
            {{ $t('panelCliente.sinDatos') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelClienteResumen",
  props: {
    resumen: { type: Object, default: () => ({}) },
    cuenta: { type: Object, default: null },
    loading: { type: Boolean, default: false },
    hayDatos: { type: Boolean, default: false },
  },
  methods: {
    fmtFechaHora(fechaStr) {
      if (!fechaStr) return "-";
      try {
        const d = new Date(fechaStr);
        if (Number.isNaN(d.getTime())) return fechaStr;
        const locale = this.$i18n?.locale === 'en' ? 'en-GB' : 'es-ES';
        return d.toLocaleString(locale);
      } catch {
        return fechaStr;
      }
    },
  },
};
</script>

<style scoped>
.mini-card {
  border: 1px solid var(--q-border);
  background: var(--q-card-alt);
  border-radius: 12px;
  padding: 12px 14px;
  height: 100%;
  min-height: 92px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 6px;
}
.mini-card .k {
  font-size: 12px;
  opacity: .7;
  line-height: 1.15;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.mini-card .v { font-size: 18px; font-weight: 700; font-family: var(--q-font-mono); font-variant-numeric: tabular-nums; }
</style>
